import React from "react";
import { formatDistanceToNow } from "date-fns";
import { Link, useSearchParams } from "react-router-dom";
import AuditEvents from "./AuditEvents";

interface AuditInfoProps {
  entity: {
    createdBy?: string;
    createdUtc?: string | null;
    modifiedBy?: string;
    modifiedUtc?: string | null;
    id?: string;
    __typename?: string;
  };
}

const AuditInfo: React.FC<AuditInfoProps> = ({ entity }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const showChanges = searchParams.get("showChanges") === "true";

  const typeName = entity.__typename || "Unknown Type";
  const id = entity.id || "Unknown ID";

  const handleClose = () => {
    searchParams.delete("showChanges");
    setSearchParams(searchParams);
  };

  if (!entity || !entity.createdUtc) {
    return null;
  }

  return (
    <div className="mb-3">
      <small>
        <em>
          <span className="text-muted me-2">Created by:</span>
          {entity.createdBy} -{" "}
          <span className="text-muted">
            {formatDistanceToNow(new Date(entity.createdUtc!), {
              addSuffix: true,
            })}
          </span>
          {entity.modifiedBy && entity.modifiedUtc && (
            <span className="ms-4">
              <span className="text-muted me-2">Modified by:</span>
              {entity.modifiedBy} -{" "}
              <span className="text-muted">
                {formatDistanceToNow(new Date(entity.modifiedUtc!), {
                  addSuffix: true,
                })}
              </span>
            </span>
          )}
        </em>
        <Link
          to={`/changes/${entity.__typename}/${entity.id}`}
          className="float-end"
        >
          All Changes
        </Link>
      </small>
    </div>
  );
};

export default AuditInfo;
